import { omit } from 'lodash';

import { BannerOrganizationAction, UPDATE_BANNERS_ORGANIZATION_IDS } from '../../actions/banners-edit/organization';
import { EntityType, mapEditorKeyToEntityId } from '../../mappers/organization/organization';
import { EditBannersState } from '../../typings/bannersEditState';

export function organizationReducer(state: EditBannersState, action: BannerOrganizationAction): EditBannersState {
    switch (action.type) {
        case UPDATE_BANNERS_ORGANIZATION_IDS: {
            const { params } = action;
            const { banners } = state;
            return {
                ...state,
                banners: {
                    ...banners,
                    ...params.reduce((acc, editorParams) => {
                        const { editorKey, organizationId } = editorParams;
                        const bannerId = mapEditorKeyToEntityId(editorKey, EntityType.banner);

                        const errors = banners[bannerId] && banners[bannerId].errors;
                        // Убирать из стора данные об ошибке в организации Справочника,
                        // при обновлении пермалинка
                        const errorsWithoutOrganization = errors && omit(errors, 'organization');

                        return {
                            ...acc,
                            [bannerId]: {
                                ...banners[bannerId],
                                permalinkId: organizationId,
                                errors: errorsWithoutOrganization
                            }
                        };
                    }, {})
                }
            };
        }
        default:
            return state;
    }
}
